export default "__VITE_ASSET__Dx1xxd7f__"